const EGDSMoreInfoTriggerSizesArray = ['small', 'medium', 'large'];
const EGDSMoreInfoTriggerWeightsArray = ['regular', 'bold'];
const EGDSMoreInfoTriggerAlignsArray = ['leading', 'center', 'trailing'];
const EGDSMoreInfoTriggerThemesArray = ['default', 'emphasis', 'positive', 'negative', 'inverse'];
export { EGDSMoreInfoTriggerAlignsArray, EGDSMoreInfoTriggerSizesArray, EGDSMoreInfoTriggerThemesArray, EGDSMoreInfoTriggerWeightsArray };